import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  photoWizardCaptureError: {
    id: 'app.inventory.photoWizard.captureError',
  },
  photoWizardDeleteError: {
    id: 'app.inventory.photoWizard.deleteError',
  },
});
